import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parseAmounts from 'utils/parseAmounts';

export function useFormatMoneyAuto(value: number | string) {
  const [formatted, setFormatted] = useState('');
  const { i18n } = useTranslation();

  useEffect(() => {
    const result = parseAmounts(value, i18n.language as any);
    setFormatted(result);
  }, [value, i18n.language]);

  return formatted;
}
